module.exports = __webpack_public_path__ + "static/media/appImage1.b12cb9c0.svg";